import { getResolvedRefDeep as e } from "@scalar/workspace-store/helpers/get-resolved-ref-deep";
import { getResolvedRef as t, mergeSiblingReferences as n } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { coerceLeafValueToSchemaType as r, getExample as i, getExampleFromSchema as a, resolveLeafSchema as o, serializeFormPropertyWithEncoding as s, serializeMultipartArray as c } from "@scalar/workspace-store/request-example";
import { json2xml as l } from "@scalar/helpers/file/json2xml";
import { unpackProxyObject as u } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var d = (e, t, n, i = !1, a) => {
	let l = [], f = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [p, m] of f) {
		if (m == null) continue;
		let f = n ? void 0 : t?.[p];
		if (i && !n) {
			let t = Array.isArray(e) ? r(m, o(a, [p])) : m, n = c(p, Array.isArray(t) ? t : m, f);
			if (n) {
				for (let e of n) l.push({
					name: e.key,
					value: e.value instanceof File ? `@${e.value.name}` : e.value,
					...e.contentType ? { contentType: e.contentType } : {}
				});
				continue;
			}
		}
		let h = f && (f.style !== void 0 || f.explode !== void 0 || f.allowReserved !== void 0), g = h || !i ? void 0 : f?.contentType, _ = n ? null : s(p, m, f);
		if (_) for (let e of _) l.push({
			name: e.key,
			value: e.value
		});
		else if (m instanceof File) {
			let e = u(m);
			l.push({
				name: p,
				value: `@${e.name}`,
				...g ? { contentType: g } : {}
			});
		} else if (g && typeof m == "object") l.push({
			name: p,
			value: JSON.stringify(u(m)),
			contentType: g
		});
		else if (i && !n && !h && typeof m == "object" && !Array.isArray(m)) l.push({
			name: p,
			value: JSON.stringify(u(m)),
			contentType: "application/json"
		});
		else if (Array.isArray(m)) for (let e of m) if (e instanceof File) {
			let t = u(e);
			l.push({
				name: p,
				value: `@${t.name}`
			});
		} else l.push({
			name: p,
			value: String(e)
		});
		else if (typeof m == "object") {
			let e = d(m, void 0, p);
			for (let t of e) l.push({
				name: `${p}.${t.name}`,
				value: t.value
			});
		} else l.push({
			name: p,
			value: String(m),
			...g ? { contentType: g } : {}
		});
	}
	return l;
}, f = ({ requestBody: r, contentType: o, example: s, requestBodyCompositionSelection: c }) => {
	let f = o || Object.keys(r.content)[0] || "", p = f === "other" ? "" : f, m = (e) => `@${u(e).name || "filename"}`, h = r.content[f]?.encoding, g = f === "multipart/form-data" || f === "application/x-www-form-urlencoded", _ = f === "application/xml", v = i(r, s, o)?.value;
	if (v !== void 0) {
		let e = typeof v == "object" && v ? u(v) : v;
		return g && typeof e == "object" && e ? {
			mimeType: p,
			params: d(e, h, void 0, f === "multipart/form-data", t(r.content[f]?.schema, n))
		} : _ && typeof e == "object" && e ? {
			mimeType: p,
			text: l(e)
		} : e instanceof File ? {
			mimeType: p,
			text: m(e)
		} : {
			mimeType: p,
			text: typeof e == "string" ? e : JSON.stringify(e)
		};
	}
	let y = t(r.content[f]?.schema);
	if (y !== void 0) {
		let t = a(e(y), {
			compositionSelection: c,
			mode: "write",
			xml: _
		}, { schemaPath: ["requestBody"] });
		if (t !== void 0) return g && typeof t == "object" && t ? {
			mimeType: p,
			params: d(t, h, void 0, f === "multipart/form-data")
		} : _ && typeof t == "object" && t ? {
			mimeType: p,
			text: l(t)
		} : {
			mimeType: p,
			text: typeof t == "string" ? t : JSON.stringify(t)
		};
	}
};
//#endregion
export { f as processBody };

//# sourceMappingURL=process-body.js.map